/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetProductDetails,
    GetAllGroups,
    GetProductCategoties,
    GetProductTypes,
    GetFactoriesByGroupID,
    GetRouteByFactoryID,
    GetFarmerDetailsByFactoryIDRouteID,
    GetFarmerCropMappingDetailsByProductIDFarmerID,
    GetAllProductVarietyByProductID,
    GetProductsByFactoryIDProductcatogeryID,
    GetFCCPurchasePriceVariationReportData,
    GetNetBenefitOfFCCPurchasesReportDetails,
    GetVCCFactoriesByGroupID,
    GetMappedMarketPrice

};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductTypes() {
    const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetRouteByFactoryID(factoryID) {
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + parseInt(factoryID));
    return response.data;
}

async function GetFarmerDetailsByFactoryIDRouteID(factoryID) {
    const response = await CommonGet('/api/Farmer/GetFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetFarmerCropMappingDetailsByProductIDFarmerID(operationEntityID, farmerID, productVarietyID) {
    const response = await CommonGet('/api/CropForcasting/GetFarmerCropMappingDetailsByProductIDFarmerID', 'operationEntityID=' + parseInt(operationEntityID) + '&farmerID=' + parseInt(farmerID) + '&cropVarietyID=' + parseInt(productVarietyID));
    return response.data;
}

async function GetAllProductVarietyByProductID(productID) {
    const response = await CommonGet('/api/Product/GetAllProductVarietyByProductID', 'productID=' + productID);
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryIDMultiSelect', 'factoryID=' + factoryID + '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetFCCPurchasePriceVariationReportData(model) {
    const response = await CommonPost('/api/FCCPurchasePriceVariationReport/GetFCCPurchasePriceVariationReportData', null, model);
    return response.data;

}

//For only VCC type factories
async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetMappedMarketPrice(operationEntityID, date) {
    const response = await CommonGet('/api/ProductMarketPriceWeb/GetMappedMarketPrice', 'operationEntityID=' + parseInt(operationEntityID) + '&date=' + date);
    return response.data;
}

async function GetNetBenefitOfFCCPurchasesReportDetails(model) {
    const response = await CommonPost('/api/NetBenefitOfFCCPurchasesReport/GetNetBenefitOfFCCPurchasesReportDetails', null, model);
    return response.data;
}




